<template>
  <form @submit.prevent="onSubmit">
    <custom-modal :show="internalShow"
                  @close="closeModal">
      <template #header>
        <h2 class="request-subscription__heading">
          Request Subscription
        </h2>
      </template>
      <div class="request-subscription__body">
        <b-form-group label="Subscription Name">
          <b-form-input v-model="subscriptionName"
                        required></b-form-input>
        </b-form-group>
        <p v-if="submitted">
          Thank you for requesting this subscription.
        </p>
      </div>
      <template #footer>
        <button class="btn btn-accent-1"
                type="submit"
                :disabled="submitted">
          <template v-if="loading">
            <font-awesome-icon icon="spinner"
                               spin></font-awesome-icon>
          </template>
          <template v-else-if="submitted">
            Requested!
          </template>
          <template v-else-if="error">
            <font-awesome-icon :icon="['far', 'times']"></font-awesome-icon>
            Error
          </template>
          <template v-else>
            <font-awesome-icon icon="chevron-right"></font-awesome-icon>
            Submit
          </template>
        </button>
      </template>
    </custom-modal>
  </form>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";
import { requestSubscription } from "~/Scripts/resources/subscriptionResource";

export default {
  name: "SubscriptionRequester",
  components: {
    CustomModal,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      subscriptionName: null,
      internalShow: false,
      loading: false,
      submitted: false,
      error: false,
    };
  },
  watch: {
    name: {
      immediate: true,
      handler ( val ) {
        this.subscriptionName = val;
      },
    },
    show: {
      immediate: true,
      handler ( val ) {
        this.internalShow = val;
      },
    },
  },
  methods: {
    closeModal () {
      this.$emit( "close" );
    },
    onSubmit () {
      this.loading = true;

      requestSubscription( this.name )
        .then( ( response ) => {
          if ( response && response.data ) {
            this.submitted = true;
          } else {
            this.error = true;
          }
        } )
        .catch( () => {
          this.error = true;
        } )
        .finally( () => {
          this.loading = false;
        } );
    },
  },
};
</script>
